/**
 * Remembers which specific wallet the user last connected with.
 *
 * The UIKit's `connectorLocalStorageKey` only ever recorded one of three connector
 * ids, so a user who connected with Rabby or OKX would be silently reconnected
 * through the generic `window.ethereum` slot on their next visit - which is whichever
 * extension won the injection race, not necessarily the one they chose. Storing the
 * EIP-6963 `rdns` lets us re-activate the same wallet.
 */
const LAST_WALLET_KEY = 'liberadex.wallet.v1.lastWalletId'

export function getLastWalletId(): string | null {
  try {
    return window.localStorage.getItem(LAST_WALLET_KEY)
  } catch {
    // Storage can throw in private-browsing modes; treat as "no memory".
    return null
  }
}

export function setLastWalletId(walletId: string): void {
  try {
    window.localStorage.setItem(LAST_WALLET_KEY, walletId)
  } catch {
    // Non-fatal: the user just won't be auto-reconnected next visit.
  }
}

export function clearLastWalletId(): void {
  try {
    window.localStorage.removeItem(LAST_WALLET_KEY)
  } catch {
    // Non-fatal.
  }
}
